import type { JSX } from 'react';
import { AppRow } from '@taki/ui';
import type { ShellAppEntry } from '../types.js';

export interface AppsScreenProps {
  /** Apps installees, dans l'ordre de `config.installedApps`. */
  apps: readonly ShellAppEntry[];
  /** Selection d'une app : navigue vers /app/$appId. */
  onPickApp: (appId: string) => void;
}

/**
 * Ecran "Apps" : liste editoriale d'AppRow, une par app installee. Chaque
 * ligne porte la pastille d'icone de l'app + son nom. Un clic navigue vers
 * l'app montee (`/app/$appId`).
 */
export function AppsScreen({ apps, onPickApp }: AppsScreenProps): JSX.Element {
  if (apps.length === 0) {
    return (
      <p className="text-sm text-ink-500">
        Aucune app n&apos;est installee pour cette organisation.
      </p>
    );
  }

  return (
    <div className="flex flex-col">
      {apps.map((app) => (
        <AppRow
          key={app.id}
          icon={app.icon}
          name={app.label}
          onClick={() => onPickApp(app.id)}
        />
      ))}
    </div>
  );
}
